query MfaSessionIssuesFilterOptions($runId: ConditionID!) {
	filter_groups: issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		type_name_group_uniq_array
		scan_name_group_uniq_array
	}
}
